import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.poll()
    this.poller = setInterval(() => this.poll(), 5000)
  }

  disconnect() {
    clearInterval(this.poller)
  }

  async poll() {
    try {
      const response = await fetch("/sync/status")

      const { fresh } = await response.json()

      if (fresh) {
        clearInterval(this.poller)
        window.location.reload()
      }
    } catch {
      // don't care
    }
  }
}
